// A tab left open across a deploy asks for a screen's old file, which the new
// build no longer has (Pages answers with the app's page), and the screen
// crashed. Reload once onto the new build; not again within a minute, so a
// real outage still shows the error. Never while offline: the browser's
// offline page would replace the app and its unsaved drafts.
export function onPreloadError(e: Event, reload = () => window.location.reload()) {
  if (!navigator.onLine) return;
  try {
    if (Date.now() - Number(sessionStorage.getItem('hf.preloadReload') ?? 0) < 60_000) return;
    sessionStorage.setItem('hf.preloadReload', String(Date.now()));
  } catch {
    return; // Blocked storage: no loop guard, so no reload.
  }
  e.preventDefault();
  reload();
}
